import axios from "axios"; // 引入axios模块

// 环境的切换
if (process.env.NODE_ENV == "development") {
  // axios.defaults.baseURL = 'http://192.168.30.137:8007';
  axios.defaults.baseURL = "http://localhost:8083/api";
  // axios.defaults.baseURL = "http://school-api.risfond.com";
} else if (process.env.NODE_ENV == "debug") {
  axios.defaults.baseURL = "";
} else if (process.env.NODE_ENV == "production") {
  axios.defaults.baseURL = "http://school-api.risfond.com";
}

// axios.defaults.baseURL = "/";


let Config = {
  TIMEOUT: 20000,//设置超时时间为6秒
}
axios.defaults.timeout = Config.TIMEOUT;

axios.interceptors.request.use(config => {
  let expires = window.localStorage.getItem('expires')
  let nowTime = new Date().getTime();
  if (nowTime > expires) {

    window.localStorage.removeItem('token')
    window.localStorage.removeItem('expires')
    window.localStorage.removeItem('userInfo')
  }
  const token = window.localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = "Bearer " + JSON.parse(token)
  }
  return config

}, error => {
  if (error.message.includes('timeout')) {   // 判断请求异常信息中是否含有超时timeout字符串
    console.log('请求超时，请稍后再试')
    return Promise.reject(error);          // reject这个错误信息
  }
  return Promise.reject(error)
})
// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    if (error.response.status) {
      return Promise.reject(error.response);
    }
  }
);

// get 方法
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

// post 方法
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}
